import React from 'react';
import { Link, useNavigate} from 'react-router-dom';
import auth from '../../../firebase.init';
import { signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import './DashNav.css'
import Loading from '../../Loading/Loading';

const DashNav = () => {
  const navigate = useNavigate()

    const [user, loading, error] = useAuthState(auth);

    let displayError;
    if (error) {
        displayError = <h5 className='text-danger text-center '>{error.message}</h5>
    }
    if (loading) {
        return <Loading></Loading>
    }
    return (
        <div>
        <section id="side_bar" className="Admin">
          <div className="sidebar_content">
            <div className="logo">
              <a href="/">
                <img src="assets/images/logo.png" alt="" />
              </a>
            </div>
            <div className="menuItem">
              <ul>

              {
                   user?.email || user?.displayName ? (
                              <>
                              <li>
                  <Link to="/" className="d_flex">
                    <div className="svg">
                      <svg
                        width={20}
                        height={26}
                        viewBox="0 0 20 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.6218 3.34717H2.365C1.71684 3.34717 1.19141 3.87261 1.19141 4.52077V23.2983C1.19141 23.9465 1.71684 24.4719 2.365 24.4719H17.6218C18.2699 24.4719 18.7954 23.9465 18.7954 23.2983V4.52077C18.7954 3.87261 18.2699 3.34717 17.6218 3.34717Z"
                          stroke="#A16CF8"
                          strokeWidth="1.67657"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.47267 1V4.52079M13.5143 1V4.52079M5.29907 9.80198H14.6879M5.29907 14.4964H12.3407M5.29907 19.1908H9.99346"
                          stroke="#A16CF8"
                          strokeWidth="1.67657"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    Website
                  </Link>
                </li>
              
                <li>
                  <Link to="/dashboard/discountOffer" className="d_flex">
                    <div className="svg">
                      <svg
                        width={23}
                        height={19}
                        viewBox="0 0 23 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.6364 8.18194H11.4548V9.81834H1.6364V8.18194ZM0 4.09094H8.18199V5.72734H0V4.09094Z"
                          fill="white"
                        />
                        <path
                          d="M22.8434 8.67782L20.3888 2.95043C20.3258 2.80322 20.2209 2.67775 20.0872 2.5896C19.9536 2.50145 19.797 2.45451 19.6368 2.4546H17.1822V0.818199C17.1822 0.601199 17.096 0.393087 16.9426 0.239645C16.7891 0.0862031 16.581 0 16.364 0H3.27284V1.6364H15.5458V11.9097C15.173 12.1262 14.8467 12.4144 14.5858 12.7576C14.3249 13.1008 14.1345 13.4922 14.0256 13.9094H8.88405C8.68491 13.1381 8.21131 12.4659 7.55202 12.0189C6.89273 11.5718 6.09302 11.3805 5.30279 11.4809C4.51257 11.5812 3.78607 11.9664 3.25949 12.5641C2.7329 13.1618 2.44238 13.931 2.44238 14.7276C2.44238 15.5242 2.7329 16.2934 3.25949 16.8911C3.78607 17.4888 4.51257 17.8739 5.30279 17.9743C6.09302 18.0747 6.89273 17.8834 7.55202 17.4363C8.21131 16.9892 8.68491 16.3171 8.88405 15.5458H14.0256C14.2036 16.248 14.6107 16.8708 15.1824 17.3157C15.7541 17.7606 16.4578 18.0021 17.1822 18.0021C17.9066 18.0021 18.6104 17.7606 19.1821 17.3157C19.7538 16.8708 20.1609 16.248 20.3388 15.5458H22.0914C22.3084 15.5458 22.5165 15.4596 22.67 15.3061C22.8234 15.1527 22.9096 14.9446 22.9096 14.7276V9.00019C22.9097 8.88935 22.8871 8.77966 22.8434 8.67782ZM5.72744 16.364C5.40379 16.364 5.08741 16.268 4.81831 16.0882C4.5492 15.9084 4.33946 15.6528 4.2156 15.3538C4.09175 15.0548 4.05934 14.7258 4.12248 14.4083C4.18562 14.0909 4.34148 13.7993 4.57033 13.5705C4.79919 13.3416 5.09076 13.1858 5.40819 13.1226C5.72562 13.0595 6.05465 13.0919 6.35366 13.2158C6.65267 13.3396 6.90825 13.5493 7.08806 13.8185C7.26787 14.0876 7.36384 14.4039 7.36384 14.7276C7.36341 15.1615 7.19086 15.5774 6.88407 15.8842C6.57728 16.191 6.16131 16.3636 5.72744 16.364ZM17.1822 4.091H19.0968L20.851 8.18199H17.1822V4.091ZM17.1822 16.364C16.8586 16.364 16.5422 16.268 16.2731 16.0882C16.004 15.9084 15.7943 15.6528 15.6704 15.3538C15.5465 15.0548 15.5141 14.7258 15.5773 14.4083C15.6404 14.0909 15.7963 13.7993 16.0251 13.5705C16.254 13.3416 16.5456 13.1858 16.863 13.1226C17.1804 13.0595 17.5094 13.0919 17.8085 13.2158C18.1075 13.3396 18.363 13.5493 18.5428 13.8185C18.7227 14.0876 18.8186 14.4039 18.8186 14.7276C18.8182 15.1615 18.6457 15.5774 18.3389 15.8842C18.0321 16.191 17.6161 16.3636 17.1822 16.364ZM21.2732 13.9094H20.3388C20.1586 13.2085 19.7509 12.5873 19.1797 12.1431C18.6084 11.6989 17.9059 11.4568 17.1822 11.4548V9.81839H21.2732V13.9094Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Discount Offer
                  </Link>
                </li>
              
                <li>
                  <Link to="/dashboard/addProduct" className="d_flex">
                    <div className="svg">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 0C5.3832 0 0 4.3068 0 9.6C0 13.0896 2.2776 16.218 6 17.9208V24L12.408 19.194C18.8364 19.0224 24 14.784 24 9.6C24 4.3068 18.6168 0 12 0ZM12 16.8H11.6004L8.4 19.2V16.2996L7.6308 16.0032C4.404 14.7612 2.4 12.3072 2.4 9.6C2.4 5.6292 6.7068 2.4 12 2.4C17.2932 2.4 21.6 5.6292 21.6 9.6C21.6 13.5708 17.2932 16.8 12 16.8Z"
                          fill="white"
                        />
                        <path
                          d="M6 6H18V8.4H6V6ZM6 10.8H14.4V13.2H6V10.8Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    Product ADD
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/productList" className="d_flex">
                    <div className="svg">
                      <svg
                        width={24}
                        height={22}
                        viewBox="0 0 24 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.3587 18.752L15.7187 13.628C15.628 12.9022 15.2753 12.2346 14.7269 11.7506C14.1785 11.2667 13.4722 10.9997 12.7407 11H10.5367C9.80565 11.0002 9.09981 11.2674 8.55182 11.7513C8.00382 12.2352 7.65139 12.9026 7.56073 13.628L6.91973 18.752C6.88455 19.0335 6.90967 19.3193 6.99341 19.5903C7.07715 19.8614 7.2176 20.1116 7.40544 20.3242C7.59327 20.5368 7.82419 20.707 8.08286 20.8235C8.34153 20.94 8.62203 21.0002 8.90573 21H14.3737C14.6574 21.0001 14.9377 20.9398 15.1963 20.8232C15.4548 20.7066 15.6856 20.5364 15.8734 20.3238C16.0611 20.1112 16.2014 19.8611 16.2851 19.5901C16.3688 19.3191 16.3939 19.0334 16.3587 18.752V18.752Z"
                          stroke="white"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11.6396 7C13.2965 7 14.6396 5.65685 14.6396 4C14.6396 2.34315 13.2965 1 11.6396 1C9.98279 1 8.63965 2.34315 8.63965 4C8.63965 5.65685 9.98279 7 11.6396 7Z"
                          stroke="white"
                          strokeWidth={2}
                        />
                        <path
                          d="M3.63965 10C4.74422 10 5.63965 9.10457 5.63965 8C5.63965 6.89543 4.74422 6 3.63965 6C2.53508 6 1.63965 6.89543 1.63965 8C1.63965 9.10457 2.53508 10 3.63965 10Z"
                          stroke="white"
                          strokeWidth={2}
                        />
                        <path
                          d="M19.6396 10C20.7442 10 21.6396 9.10457 21.6396 8C21.6396 6.89543 20.7442 6 19.6396 6C18.5351 6 17.6396 6.89543 17.6396 8C17.6396 9.10457 18.5351 10 19.6396 10Z"
                          stroke="white"
                          strokeWidth={2}
                        />
                        <path
                          d="M3.63925 13H3.33325C2.85981 12.9999 2.4017 13.1678 2.04042 13.4738C1.67914 13.7798 1.43813 14.204 1.36025 14.671L1.02725 16.671C0.979458 16.9575 0.994667 17.2511 1.07181 17.5311C1.14896 17.8112 1.2862 18.0711 1.47397 18.2928C1.66175 18.5144 1.89556 18.6925 2.15914 18.8146C2.42272 18.9368 2.70974 19 3.00025 19H6.63925M19.6392 13H19.9452C20.4187 12.9999 20.8768 13.1678 21.2381 13.4738C21.5993 13.7798 21.8404 14.204 21.9182 14.671L22.2512 16.671C22.299 16.9575 22.2838 17.2511 22.2067 17.5311C22.1295 17.8112 21.9923 18.0711 21.8045 18.2928C21.6167 18.5144 21.3829 18.6925 21.1194 18.8146C20.8558 18.9368 20.5687 19 20.2782 19H16.6392"
                          stroke="white"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    Product List
                  </Link>
                </li>
                <li>
                  <a href="/" className="d_flex">
                    <div className="svg">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.64286 1V4.14286L8.07143 4.92857L5.71429 2.57143L2.57143 5.71429L4.92857 8.07143L4.14286 9.64286H1V14.3571H4.14286L4.92857 15.9286L2.57143 18.2857L5.71429 21.4286L8.07143 19.0714L9.64286 19.8571V23H14.3571V19.8571L15.9286 19.0714L18.2857 21.4286L21.4286 18.2857L19.0714 15.9286L19.8571 14.3571H23V9.64286H19.8571L19.0714 8.07143L21.4286 5.71429L18.2857 2.57143L15.9286 4.92857L14.3571 4.14286V1H9.64286Z"
                          stroke="white"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12.0003 15.1429C13.736 15.1429 15.1431 13.7358 15.1431 12C15.1431 10.2643 13.736 8.85718 12.0003 8.85718C10.2645 8.85718 8.85742 10.2643 8.85742 12C8.85742 13.7358 10.2645 15.1429 12.0003 15.1429Z"
                          stroke="white"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    Offers
                  </a>
                </li>
               
                <li>
                  <a href="/" className="d_flex">
                    <div className="svg">
                      <svg
                        width={20}
                        height={20}
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.41 9.58L10.41 0.58C10.05 0.22 9.55 0 9 0H2C0.9 0 0 0.9 0 2V9C0 9.55 0.22 10.05 0.59 10.42L9.59 19.42C9.95 19.78 10.45 20 11 20C11.55 20 12.05 19.78 12.41 19.41L19.41 12.41C19.78 12.05 20 11.55 20 11C20 10.45 19.77 9.94 19.41 9.58ZM11 18.01L2 9V2H9V1.99L18 10.99L11 18.01Z"
                          fill="white"
                        />
                        <path
                          d="M4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <button onClick={() => signOut(auth)}>  LogOut</button>
                   
                  </a>
                </li>
                              </>
                            ):(
                              navigate('/login')
                            )
                }



                
                
              </ul>
            </div>
            {displayError}
          </div>
        </section>
      </div>
    );
};

export default DashNav;